import React, { useState } from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import UpgradeForm from './UpgradeForm';

function Upgrade() {

  const [UpgradeSuccess, setUpgradeSuccess] = useState(false);
  const [userEmail, setUserEmail] = useState('');

  const handleUpgradeSuccess = (email) => {
    setUpgradeSuccess(true);
    setUserEmail(email);
  };

  return (
    <>
      <section className="theme-light section m-0 p-0" data-theme="light">
        <div className='fullHeight m-0 p-0 is-flex is-flex-direction-column is-justify-content-space-between'>
          <div>
            {/* Navigation */}
            <div className='columns is-flex is-flex-direction-rows is-justify-content-center'>
              <div className="m-0 p-0 column is-11 is-offset-1"><Navigation /></div>
            </div>
            
            {/* Content */}
            <div className='pb-6 columns is-flex is-flex-direction-rows is-justify-content-center main-content'>
              <div className="m-0 p-0 content column is-4-fullhd is-4-widescreen is-6-desktop is-8-tablet is-10-mobile">
                <h1 className='pt-4 px-0 pb-0 m-0'>
                  {UpgradeSuccess ? 'Thank you!' : 'Upgrade Nudgemail'}
                </h1>
                {!UpgradeSuccess ? (
                  <>
                    <h3 className='py-2 px-0 m-0 is-bold'>
                      You're the real MVP!
                    </h3>
                    <p>
                      Thanks for being part of Nudgemail! By upgrading, you're not just getting more Nudge power—you're fueling a small but mighty team (and keeping our caffeine supply alive). Future-you approves.
                    </p>
                  </>
                ) : (
                  <h2 className='py-2 px-0 m-0'>
                    Please check your email at {userEmail} to confirm your account. There is a chance it got stuck in your spam folder.
                  </h2>
                )}
                <UpgradeForm onUpgradeSuccess={handleUpgradeSuccess} showForm={!UpgradeSuccess} />
              </div>
            </div>
          </div>
          
          {/* Footer */}
          <div className='footer m-0 p-0 columns is-flex is-flex-direction-rows is-justify-content-center is-align-items-center'>
            <div className="m-0 p-0 column is-11 is-10-mobile"><Footer /></div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Upgrade;